import React, { useEffect, useState } from 'react';
import DashEstablishmentSlot from './DashEstablishmentSlot';
import ContainerClickProvider from 'context/dash/ContainerClick';
import styled from 'styled-components';
import breakpoints from 'theme/breakpoints';
import { Column } from 'styled/alignment/Column';
import Text from 'components/_UI/Text';
import OnSelectMenuProvider from 'context/general/OnSelectMenu';
import { useOnSelectMenu } from 'context/general/OnSelectMenu';
import BankAccountWarning from './BankAccountWarning';
import { useUser } from 'context/user/User';
import CollapseProvider from 'context/general/Collapse';

export default function DashEstablishmentContainer({ children, title, rightSlot: RightSlot = null }) {
    return (
        <OnSelectMenuProvider>
            <ContainerClickProvider>
                <CollapseProvider>
                    <DashEstablishmentContainerContent title={title} RightSlot={RightSlot}>
                        {children}
                    </DashEstablishmentContainerContent>
                </CollapseProvider>
            </ContainerClickProvider>
        </OnSelectMenuProvider>
    );
}

function DashEstablishmentContainerContent({ children, title, RightSlot }) {
    const { user } = useUser();
    const { isSidebarCollapsed } = useOnSelectMenu();
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (user) {
            setLoaded(true);
        }
    }, [user]);

    return (
        <DashEstablishmentSlot>
            <StyledContainer $collapsed={isSidebarCollapsed}>

                {loaded && !user?.has_bank_account && <BankAccountWarning />}

                {!!loaded && (
                    <>
                        <ContentHeader>
                            <ContentTitle>
                                <Text name='subtitle'>{title}</Text>
                            </ContentTitle>

                            {RightSlot && <RightSlot />}
                        </ContentHeader>

                        <WrapperContent>
                            {children}
                        </WrapperContent>
                    </>
                )}

            </StyledContainer>
        </DashEstablishmentSlot>
    );
}

const StyledContainer = styled(Column)`
    @media screen and (min-width: ${breakpoints.lg}) {
        padding-left: ${({ $collapsed }) => $collapsed ? '96px' : '260px'};
        padding-right: 50px;
        padding-bottom: 20px;
        transition: padding-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
`;

const WrapperContent = styled.div`
    padding: 10px 0;
`;

const ContentHeader = styled(Column)`
    display: flex;
    width: 100%;
    align-items: center;
    text-align: center;
    justify-content: center;

    @media screen and (min-width: ${breakpoints.md}) {
        display: flex;
        margin-top: 15px;
        flex-direction: row;
        justify-content: space-between;
        text-align: left;

        & > h2 {
            width: 100%;
            padding-bottom: 0;
        }
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        display: flex;
        margin-top: 25px;
        flex-direction: row;
        justify-content: space-between;
        & > h2 { width: 100%; }
    }

    @media screen and (min-width: ${breakpoints.xl}) {
        padding: unset;
        & > h2 { width: 100%; }
    }
`;

const ContentTitle = styled.div`
    width: 100%;
    margin-bottom: 20px;

    & > h2 { width: 100%; padding-bottom: 0; }

    @media screen and (min-width: ${breakpoints.sm}) {
        margin-bottom: 20px;
        & > h2 { width: 100%; padding-bottom: 0; }
    }

    @media screen and (min-width: ${breakpoints.md}) {
        margin-bottom: unset;
    }

    @media screen and (min-width: ${breakpoints.xl}) {
        margin-bottom: unset;
        margin-left: 0;
        & > h2 { width: 100%; padding-bottom: 0; }
    }
`;
